export const processType = [
    {id:1, name:'CNC Machining'},
    {id:2, name:'3D Printing'},
    {id:3, name:'Sheet Metal Fabrication'},
    {id:4, name:'Injection Moulding/Casting'},
    {id:5, name:'Complete Assembly'},
    {id:6,name:'Vacuum casting'},
    {id:7,name:'Jigs and Fixtures'},
    {id:8, name:'Off-the-shelf parts (OEM)'},
    {id:9, name:'3D Printing'},
    {id:10,name: 'CNC Machining'},
    {id:11, name:'Other'}
]
export const commandFields = {
    MaterialType: "",
    surfaceFinish: "",
    SubMaterial: "",
    surfaceTreatment: "",
    tolerance: "",
    partMarking: "",
    Notes: "",
    noOfThread: 0,
    Attachment: [],
    Qty: 1,
    price: 0,
    layer: "",
    XDimensionValue : 0,
    YDimensionValue : 0,
    ZDimensionvalue : 0,
    zAxisOfPrinting : 0,
    cylindricalArea: 0,
    planarArea: 0,
    factorForExcessVolume: 0,
    densityOfMaterial : 0,
    costOfMaterial : 0,
    rateOfPrinting: 0,
    rateOfRecoating: 0,
    printingCost: 0,
    algorithmMaterialCost: 0,
    timeTakenForPrintingInHours: 0,
    timeTakenOrRecoatingInHours: 0,
    algorithmOverheadsCost: 0,
    algorithmPrice: 0,
    partMakingFactor: 0,
    finalCost: 0,
    algorithmPrice1: 0,
    algorithmPrice2: 0,
    errors: {
        MaterialType: false,
        surfaceFinish: false,
        SubMaterial: false,
        surfaceTreatment: false,
        tolerance: false,
        partMarking: false,
        Notes: false,
        noOfThread:false,
        Attachment: false,
        SelectProcess: false,
        Qty: false,
        price: false,
        layer: false,
        XDimensionValue : false,
        YDimensionValue : false,
        ZDimensionvalue : false,
        zAxisOfPrinting : false,
        cylindricalArea: false,
        planarArea: false,
        factorForExcessVolume: false,
        densityOfMaterial : false,
        costOfMaterial : false,
        rateOfPrinting: false,
        rateOfRecoating: false,
        printingCost: false,
        algorithmMaterialCost: false,
        timeTakenForPrintingInHours: false,
        timeTakenOrRecoatingInHours: false,
        algorithmOverheadsCost: false,
        algorithmPrice: false,
        partMakingFactor: false,
        finalCost: false,
        algorithmPrice1: false,
        algorithmPrice2: false,
    }
}


export const raiseIssueSteps =["Select parts with issues", "Select issue(s)",   "Issue Description"]
export const qualityRelatedIssue =["Wrong part(s)", "Wrong Dimensions",   "Missing Parts","Wrong Material"]
export const orderRelatedIssue =["Wrong billing address", "Wrong shipping address",   "Missing Parts","Wrong Material"]
export const quoteVersionDescriptions = [
    {id:'CC',value:'Customer Created'},
    {id:'CE',value:'Customer Edits'},
    {id:'DU',value:'Design Update'},
    {id:'AR',value:'Admin Review'},
    {id:'CU',value:'Cost Updated'},
    {id:'RO',value:'Repeat Order'},
    {id:'SP', value:'Spare Parts'},
    {id:'AC',value:'Admin Created'},
]

export const pathNameForPublicAccess = ["/Sustainability-CSR","/privacy-policy","/terms-of-service","/view-order-details/"];
export const projectCategory = [
    {name:"3D Printing",path:"/projects/three-d-printing"},
    {name:"Casting",path:"/projects/casting"},
    {name:"CNC Machining",path:"/projects/cnc-machining"},
    {name:"Completed Assembly",path:"/projects/complete-assembly"},
    // {name:"Packaging",path:"/projects/packaging"}
];

export const MATERAILS_VALID_FOR_ML = ['Aluminium',"Nylon","PEEK","PMMA","Polycarbonate","PTFE","Stainless Steel",]